import {
  EventTemplateFieldAttributeName,
  EventTemplateFieldAttributeNames,
  EventTemplateFields,
} from '../types/eventField';
import { EventType, EventTemplateStatusSchema, EventTemplateStatus } from '../types';
import {
  TemplateDraft,
  TemplateEffective,
  TemplateArchived,
  TemplateForApproval,
  TemplateApprovalDeclined,
  TemplateSuperseded,
} from '../displayStrings';

export const getBlankStep = () => {
  return {
    id: null,
    workflow_id: null,
    template_id: null,
    succeeds: null,
    precedes: null,
    order: Infinity,
    start_time_constraint: null,
    form_template_id: null,
    time_limit: 0,
  };
};

export const isFieldVisible = (
  templateFields: EventTemplateFields,
  fieldName: EventTemplateFieldAttributeName,
): boolean => {
  if (templateFields === null || templateFields === undefined) {
    return new Set([
      EventTemplateFieldAttributeNames.enum.product,
      EventTemplateFieldAttributeNames.enum.root_cause,
      EventTemplateFieldAttributeNames.enum.risk,
    ] as string[]).has(fieldName);
  }

  return templateFields.some((field) => field.attribute_name === fieldName);
};

export const statusToDisplayString: { [key in EventTemplateStatus]: string } = {
  draft: TemplateDraft,
  effective: TemplateEffective,
  archived: TemplateArchived,
  for_approval: TemplateForApproval,
  approval_declined: TemplateApprovalDeclined,
  superseded: TemplateSuperseded,
};

export const templateStatus = (template: EventType): EventTemplateStatus => {
  if (!template.active) {
    return EventTemplateStatusSchema.enum.archived;
  }
  return template.status;
};
